import React, { Fragment, useEffect, useMemo, useState } from "react";
import axios from "axios";
import VerDetalle from "../Modals/crear/VerDetalleEstandar";
import CreaEstandares from "../Modals/crear/CreaEstandares";
import Cookies from "universal-cookie";

function InfoEstandares(props) {
  const cookies = new Cookies();

  const [list, setList] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [sedeSeleccionada, setSedeSeleccionada] = useState("");
  const [registrosPorPagina, setRegistrosPorPagina] = useState(10);
  const [paginaActual, setPaginaActual] = useState(1);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEstandarPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((response) => {
        setList(response.data);
        setPaginaActual(1);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.idSolicitud]);

  // Obtener sedes únicas
  const sedes = useMemo(() => {
    const sedesUnicas = list
      .map((item) => item.sede)
      .filter((sede) => sede !== null && sede !== undefined && sede !== "");

    return [...new Set(sedesUnicas)].sort();
  }, [list]);

  // Filtrar información
  const listaFiltrada = useMemo(() => {
    const texto = busqueda.toLowerCase().trim();

    return list.filter((item) => {
      const coincideBusqueda =
        !texto ||
        String(item.codigoEstandar || "")
          .toLowerCase()
          .includes(texto) ||
        String(item.aplicabilidad || "")
          .toLowerCase()
          .includes(texto) ||
        String(item.fechaCorte || "")
          .toLowerCase()
          .includes(texto);

      const coincideSede =
        !sedeSeleccionada || String(item.sede) === sedeSeleccionada;

      return coincideBusqueda && coincideSede;
    });
  }, [list, busqueda, sedeSeleccionada]);

  // Calcular total de páginas
  const totalPaginas = Math.ceil(listaFiltrada.length / registrosPorPagina);

  // Ajustar página si queda fuera del rango
  useEffect(() => {
    if (totalPaginas > 0 && paginaActual > totalPaginas) {
      setPaginaActual(totalPaginas);
    }

    if (totalPaginas === 0 && paginaActual !== 1) {
      setPaginaActual(1);
    }
  }, [totalPaginas, paginaActual]);

  // Registros que se muestran en la página actual
  const indiceInicial = (paginaActual - 1) * registrosPorPagina;
  const indiceFinal = indiceInicial + registrosPorPagina;

  const registrosPagina = listaFiltrada.slice(indiceInicial, indiceFinal);

  // Cambiar búsqueda
  const handleBusqueda = (e) => {
    setBusqueda(e.target.value);
    setPaginaActual(1);
  };

  // Cambiar sede
  const handleSede = (e) => {
    setSedeSeleccionada(e.target.value);
    setPaginaActual(1);
  };

  // Cambiar cantidad de registros
  const handleRegistrosPorPagina = (e) => {
    setRegistrosPorPagina(Number(e.target.value));
    setPaginaActual(1);
  };

  // Página anterior
  const paginaAnterior = () => {
    if (paginaActual > 1) {
      setPaginaActual(paginaActual - 1);
    }
  };

  // Página siguiente
  const paginaSiguiente = () => {
    if (paginaActual < totalPaginas) {
      setPaginaActual(paginaActual + 1);
    }
  };

  return (
    <Fragment>
      <div className="text-center">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Estándares</h6>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                {cookies.get("tipo_Usuario") == 2 ? (
                  <CreaEstandares
                    idSolicitud={props.idSolicitud}
                    idInstitucion={props.idInstitucion}
                  />
                ) : (
                  <h1></h1>
                )}

                {/* Barra de filtros */}
                <div className="row mb-3 mt-3">
                  {/* Buscar */}
                  <div className="col-md-4">
                    <label className="font-weight-bold">Buscar</label>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Código, aplicabilidad o fecha..."
                      value={busqueda}
                      onChange={handleBusqueda}
                    />
                  </div>

                  {/* Filtro sede */}
                  <div className="col-md-4">
                    <label className="font-weight-bold">Sede</label>

                    <select
                      className="form-control"
                      value={sedeSeleccionada}
                      onChange={handleSede}
                    >
                      <option value="">Todas las sedes</option>

                      {sedes.map((sede, index) => (
                        <option key={index} value={sede}>
                          {sede}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Cantidad */}
                  <div className="col-md-4">
                    <label className="font-weight-bold">Mostrar</label>

                    <select
                      className="form-control"
                      value={registrosPorPagina}
                      onChange={handleRegistrosPorPagina}
                    >
                      <option value={10}>10 registros</option>
                      <option value={50}>50 registros</option>
                      <option value={100}>100 registros</option>
                    </select>
                  </div>
                </div>

                {/* Descargar */}
                <div className="mb-3">
                  <a
                    href="../../formatos/FormatoEstandares.csv"
                    download
                    className="btn btn-primary"
                  >
                    Descargar Formato
                  </a>
                </div>

                {/* Tabla */}
                <table
                  className="table table-bordered"
                  id="dataTable"
                  width="100%"
                  cellSpacing="0"
                >
                  <thead>
                    <tr>
                      <th>Codigo</th>
                      <th>Aplicabilidad</th>
                      <th>Fecha</th>
                      <th>Sede</th>
                      <th>Total</th>
                      <th>Detalle</th>
                    </tr>
                  </thead>

                  <tbody>
                    {registrosPagina.length > 0 ? (
                      registrosPagina.map((item) => {
                        const ponderado =
                          (Number(item.enfoqueSistemico || 0) +
                            Number(item.enfoqueProactivo || 0) +
                            Number(item.enfoqueEvaluado || 0) +
                            Number(item.despliegueInstitucion || 0) +
                            Number(item.apropiacionCliente || 0) +
                            Number(item.pertinencia || 0) +
                            Number(item.consistencia || 0) +
                            Number(item.avanceMedicion || 0) +
                            Number(item.tendencia || 0) +
                            Number(item.comparacion || 0)) /
                          10;

                        const total = ponderado.toFixed(2);

                        return (
                          <tr key={item.id}>
                            <td>{item.codigoEstandar}</td>
                            <td>{item.aplicabilidad}</td>
                            <td>{item.fechaCorte}</td>
                            <td>{item.sede}</td>
                            <td>{total}</td>

                            <td>
                              <VerDetalle idE={item.id} />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No se encontraron estándares.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* Información de registros */}
                <div className="row align-items-center mt-3">
                  <div className="col-md-4 text-left">
                    <span className="text-muted">
                      Mostrando{" "}
                      {listaFiltrada.length === 0 ? 0 : indiceInicial + 1} -{" "}
                      {Math.min(indiceFinal, listaFiltrada.length)} de{" "}
                      {listaFiltrada.length} registros
                    </span>
                  </div>

                  {/* Paginación */}
                  <div className="col-md-4 text-center">
                    <button
                      type="button"
                      className="btn btn-outline-primary mr-2"
                      onClick={paginaAnterior}
                      disabled={paginaActual === 1}
                    >
                      Anterior
                    </button>

                    <span className="font-weight-bold">
                      Página {paginaActual} de{" "}
                      {totalPaginas === 0 ? 1 : totalPaginas}
                    </span>

                    <button
                      type="button"
                      className="btn btn-outline-primary ml-2"
                      onClick={paginaSiguiente}
                      disabled={
                        paginaActual === totalPaginas || totalPaginas === 0
                      }
                    >
                      Siguiente
                    </button>
                  </div>

                  <div className="col-md-4 text-right">
                    <span className="text-muted">
                      Total: {listaFiltrada.length}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default InfoEstandares;
